var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-screen bg-white"},[_c('div',{staticClass:"w-screen h-screen bg-cover",style:({
      'background-image':
        'url(' + require('../assets/images/background_kiosk.png') + ')',
    })},[_c('img',{staticClass:"w-screen kioskFotoScreen"})]),_c('div',{},[_vm._v(" ezoifezi ")])])}
var staticRenderFns = []

export { render, staticRenderFns }